var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"top":_vm.top,"bottom":"","right":""},model:{value:(_vm.snackbarOpen),callback:function ($$v) {_vm.snackbarOpen=$$v},expression:"snackbarOpen"}},[_vm._v("\n  "+_vm._s(_vm.messageProp)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }